<template>
    <div class="base-trumpet-explain" :class="{'terexp-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="header">
                <div class="back-img" @click="$router.back()">
                    <img class="back" src="~images/back.png" />
                </div>
                <div class="title">小号说明</div>
            </div>
            <div class="content-auto">
                <div class="tips">
                    <div>1、在每个游戏里可创建最多10个小号；</div>
                    <div class="mar">2、每个小号相互独立，小号出售、回收不影响其他小号；</div>
                    <div class="mar">3、换区时，建议创建新的小号进入</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BaseTrumpetExplain'
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-trumpet-explain {
        width: 864px;
        min-height: 888px;
        overflow: hidden;
        padding-bottom: 60px;
        border-radius: 18px;
        background: rgba(0, 0, 0, 0.8);
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.3s;
        .content {
            flex: 1;
            overflow-y: scroll;
            .header {
                height: 132px;
                background: rgba($color, 0.8);
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                .back-img {
                    width: 192px;
                    height: 132px;
                    position: absolute;
                    left: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .back {
                        width: 72px;
                        height: 72px;
                    }
                }
                .title {
                    font-size: 51px;
                    text-align: center;
                }
            }
            .content-auto {
                padding: 0 60px;
                overflow: hidden;
                .tips {
                    font-size: 39px;
                    margin: 60px 0 30px;
                }
                .tips .mar {
                    margin-top: 40px;
                }
            }
        }
    }
    // 竖屏css
    .terexp-sp {
        width: 1570px;
        min-height: 1614px;
        padding-bottom: 90px;
        border-radius: 32px;
        .content {
            .header {
                height: 240px;
                .back-img {
                    width: 290px;
                    height: 240px;
                    .back {
                        width: 130px;
                        height: 130px;
                    }
                }
                .title {
                    font-size: 92px;
                }
            }
            .content-auto {
                padding: 0 90px;
                .tips {
                    font-size: 70px;
                    margin: 90px 0 54px;
                }
                .tips .mar {
                    margin-top: 72px;
                }
            }
        }
    }
</style>